<template>
  <div class="pay-password-container">
    <div class="line1">请输入支付密码</div>
    <div class="password-box">
      <el-input
        ref="pwdInput"
        v-model="password"
        type="password"
        maxlength="6"
        class="pwd-input"
        @input="handleInput"
        @keyup.delete.native="handleDelete"
      />
      <div class="display-box">
        <div
          v-for="(item, index) in displayValue"
          :key="index"
          class="pwd-item"
          :class="{ active: password.length > index }"
        >
          {{ password.length > index ? "*" : "" }}
        </div>
      </div>
    </div>
    <div class="line2" @click="forgetPSW">{{ toastText }}</div>
    <div class="line3">
      <el-button>取消</el-button>
      <el-button type="primary" @click="surePay">确认</el-button>
    </div>
  </div>
</template>

<script>
import { verifyPay } from "@/api/pay";
export default {
  name: "PayPassword",
  data() {
    return {
      password: "",
      displayValue: new Array(6).fill(""),
      toastText: "忘记密码?"
    };
  },
  methods: {
    forgetPSW() {
      if (this.toastText === "忘记密码?") {
        this.$router.push({
          path: "/systemManage/payPassword/editPassword"
        });
      }
    },
    surePay() {
      if (this.password.length != 6) {
        this.$message({
          message: "请输入6位支付密码",
          type: "warning"
        });
        return;
      }
      let data = {
        payPassword: this.password + ""
      };
      console.log("payPassword", typeof data.payPassword);
      const rLoading = this.openLoading();
      verifyPay(data).then(res => {
        if (res.status == 0) {
          this.$emit("complete");
        }
        rLoading.close();
      });
    },
    handleInput(val) {
      // 只允许输入数字
      this.password = val.replace(/\D/g, "").slice(0, 6);
      // 更新显示值
      this.updateDisplayValue();
    },
    handleDelete() {
      this.updateDisplayValue();
    },
    updateDisplayValue() {
      const pwd = this.password.split("");
      this.displayValue = new Array(6)
        .fill("")
        .map((_, index) => pwd[index] || "");
    },
    // 清空密码
    clear() {
      this.password = "";
      this.displayValue = new Array(6).fill("");
    },
    // 获取密码值
    getValue() {
      return this.password;
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-password-container {
  .password-box {
    position: relative;
    width: 300px;
    margin: 0 auto;

    .pwd-input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 45px;
      opacity: 0;
      z-index: 1;
    }

    .display-box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 45px;

      .pwd-item {
        width: 45px;
        height: 45px;
        line-height: 43px;
        text-align: center;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        font-size: 20px;
        transition: all 0.3s;

        &.active {
          border-color: #409eff;
          background-color: #f5f7fa;
        }
      }
    }
  }
}
.line1 {
  text-align: center;
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  margin-top: 40px;
  font-weight: bold;
}
.line2 {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 250px;
  cursor: pointer;
}
.line3 {
  text-align: center;
  margin-top: 50px;
  margin-left: 150px;
}
</style>
